import * as React from 'react';
import { CompositeKeys } from 'app/types-shared';
import { STATE } from 'app/constants';
import { useTranslation } from 'app/infrastructure/translate/hooks';
import { entryLogTranslation } from 'app/area/case/features/entry-log/menu-item/constants';
import { CaseListingRefreshContext } from 'app/area/case-report/case-listing/case-listing-refresh-context';
import { EntryLogMenuItem, loadOpenEntryPath } from 'app/area/case/features/entry-log/menu-item/entry-log-menu-item';
//
/**
 * State of the New entry / Egress menu item of the case header menu in reports.
 * `loadOpenEntry` is only set when the item can be shown, it is called when the menu opens.
 */
export const useHeaderEntryLog = (caseId: number, involvedPersonPath?: CompositeKeys) => {
  const [openEntryPath, setOpenEntryPath] = React.useState<CompositeKeys | null | undefined>(undefined);
  const onChanged = React.useContext(CaseListingRefreshContext);
  const loadOpenEntry = involvedPersonPath ? () => loadOpenEntryPath(caseId, involvedPersonPath) : undefined;

  return { openEntryPath, setOpenEntryPath, onChanged, loadOpenEntry };
};

interface HeaderEntryLogMenuItemProps {
  caseId: number;
  involvedPersonPath?: CompositeKeys;
  callsToActions: any;
  entryLog: ReturnType<typeof useHeaderEntryLog>;
}

export const HeaderEntryLogMenuItem = (
  { caseId, involvedPersonPath, callsToActions, entryLog }: HeaderEntryLogMenuItemProps
) => {
  const translation = useTranslation(STATE.caseListing, entryLogTranslation);

  return <EntryLogMenuItem
    callsToActions={callsToActions}
    caseId={caseId}
    involvedPersonPath={involvedPersonPath}
    translation={translation}
    openEntryPath={entryLog.openEntryPath}
    onOpenEntryPathChange={entryLog.setOpenEntryPath}
    onChanged={entryLog.onChanged} />;
};
